import Vue from 'vue';
import VuePictureSwipe from 'vue-picture-swipe';

Vue.component(`vue-picture-swipe`, VuePictureSwipe);
